/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_TradeOrder_TradeOrderDataDto_Wealthlane_AwardSettlementService_Application_Contracts } from '../models/Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_TradeOrder_TradeOrderDataDto_Wealthlane_AwardSettlementService_Application_Contracts';
import type { Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_TradeOrder_TradeOrderGroupResultDto_Wealthlane_AwardSettlementService_Application_Contracts } from '../models/Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_TradeOrder_TradeOrderGroupResultDto_Wealthlane_AwardSettlementService_Application_Contracts';
import type { Wealthlane_AwardSettlementService_Dtos_Common_GenericBackgroundValidationResponseDto } from '../models/Wealthlane_AwardSettlementService_Dtos_Common_GenericBackgroundValidationResponseDto';
import type { Wealthlane_AwardSettlementService_Dtos_Common_GenericTaskResponseDto } from '../models/Wealthlane_AwardSettlementService_Dtos_Common_GenericTaskResponseDto';
import type { Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto } from '../models/Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto';
import type { Wealthlane_AwardSettlementService_Dtos_TradeOrder_ExportPlacedOrderRequestDto } from '../models/Wealthlane_AwardSettlementService_Dtos_TradeOrder_ExportPlacedOrderRequestDto';
import type { Wealthlane_AwardSettlementService_Dtos_TradeOrder_PaginatedPlaceOrderDashboardDto } from '../models/Wealthlane_AwardSettlementService_Dtos_TradeOrder_PaginatedPlaceOrderDashboardDto';
import type { Wealthlane_AwardSettlementService_Dtos_TradeOrder_PlaceOrderDashboardDto } from '../models/Wealthlane_AwardSettlementService_Dtos_TradeOrder_PlaceOrderDashboardDto';
import type { Wealthlane_AwardSettlementService_Dtos_TradeOrder_TradeOrderDataDto } from '../models/Wealthlane_AwardSettlementService_Dtos_TradeOrder_TradeOrderDataDto';
import type { Wealthlane_AwardSettlementService_Dtos_TradeOrder_TradeOrderExportDto } from '../models/Wealthlane_AwardSettlementService_Dtos_TradeOrder_TradeOrderExportDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TradeOrderService {

    /**
     * @param requestBody 
     * @returns string OK
     * @throws ApiError
     */
    public static postApiAwardSettlementApiAppTradeOrderExportPlacedOrders(
requestBody?: Wealthlane_AwardSettlementService_Dtos_TradeOrder_ExportPlacedOrderRequestDto,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award-settlement/api/app/trade-order/export-placed-orders',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param orderStatusId 
     * @param cancelStatusId 
     * @param createdDate 
     * @param filter 
     * @param companyIds 
     * @param companyTickers 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_TradeOrder_TradeOrderDataDto_Wealthlane_AwardSettlementService_Application_Contracts OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiAppTradeOrderPlacedOrders(
orderStatusId?: Array<string>,
cancelStatusId?: Array<string>,
createdDate?: string,
filter?: string,
companyIds?: Array<string>,
companyTickers?: Array<string>,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_TradeOrder_TradeOrderDataDto_Wealthlane_AwardSettlementService_Application_Contracts> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/app/trade-order/placed-orders',
            query: {
                'OrderStatusId': orderStatusId,
                'CancelStatusId': cancelStatusId,
                'CreatedDate': createdDate,
                'Filter': filter,
                'CompanyIds': companyIds,
                'CompanyTickers': companyTickers,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static putApiAwardSettlementApiAppTradeOrderPlacedOrders(
requestBody?: Array<Wealthlane_AwardSettlementService_Dtos_TradeOrder_TradeOrderExportDto>,
): CancelablePromise<Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award-settlement/api/app/trade-order/placed-orders',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param tradeOrderId 
     * @returns Wealthlane_AwardSettlementService_Dtos_TradeOrder_TradeOrderDataDto OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiAppTradeOrderPlacedOrdersById(
tradeOrderId: string,
): CancelablePromise<Wealthlane_AwardSettlementService_Dtos_TradeOrder_TradeOrderDataDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/app/trade-order/placed-orders-by-id/{tradeOrderId}',
            path: {
                'tradeOrderId': tradeOrderId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param orderStatusId 
     * @param cancelStatusId 
     * @param companyTickers 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_TradeOrder_TradeOrderGroupResultDto_Wealthlane_AwardSettlementService_Application_Contracts OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiTradeOrderGroupedTradeOrder(
orderStatusId?: Array<string>,
cancelStatusId?: Array<string>,
companyTickers?: Array<string>,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_TradeOrder_TradeOrderGroupResultDto_Wealthlane_AwardSettlementService_Application_Contracts> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/trade-order/grouped-trade-order',
            query: {
                'OrderStatusId': orderStatusId,
                'CancelStatusId': cancelStatusId,
                'CompanyTickers': companyTickers,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param orderDate 
     * @returns Wealthlane_AwardSettlementService_Dtos_TradeOrder_PlaceOrderDashboardDto OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiTradeOrderOrders(
orderDate: string,
): CancelablePromise<Array<Wealthlane_AwardSettlementService_Dtos_TradeOrder_PlaceOrderDashboardDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/trade-order/{orderDate}/orders',
            path: {
                'orderDate': orderDate,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param orderStatusId 
     * @param cancelStatusId 
     * @param companyTickers 
     * @returns Wealthlane_AwardSettlementService_Dtos_TradeOrder_PlaceOrderDashboardDto OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiAppTradeOrderPlacedOrdersDashboard(
orderStatusId?: Array<string>,
cancelStatusId?: Array<string>,
companyTickers?: Array<string>,
): CancelablePromise<Array<Wealthlane_AwardSettlementService_Dtos_TradeOrder_PlaceOrderDashboardDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/app/trade-order/placed-orders-dashboard',
            query: {
                'OrderStatusId': orderStatusId,
                'CancelStatusId': cancelStatusId,
                'CompanyTickers': companyTickers,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param orderStatusId 
     * @param cancelStatusId 
     * @param dateTime 
     * @param companyIds 
     * @param maxResultCount 
     * @param sorting 
     * @param skipCount 
     * @returns Wealthlane_AwardSettlementService_Dtos_TradeOrder_PaginatedPlaceOrderDashboardDto OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiV2TradeOrderPlacedOrderDashboard(
orderStatusId?: Array<string>,
cancelStatusId?: Array<string>,
dateTime?: string,
companyIds?: Array<string>,
maxResultCount?: number,
sorting?: string,
skipCount?: number,
): CancelablePromise<Wealthlane_AwardSettlementService_Dtos_TradeOrder_PaginatedPlaceOrderDashboardDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/v2/trade-order/placed-order-dashboard',
            query: {
                'OrderStatusId': orderStatusId,
                'CancelStatusId': cancelStatusId,
                'DateTime': dateTime,
                'CompanyIds': companyIds,
                'MaxResultCount': maxResultCount,
                'Sorting': sorting,
                'SkipCount': skipCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardSettlementApiAppTradeOrderImportOrders(
formData?: {
File?: Blob;
},
): CancelablePromise<Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award-settlement/api/app/trade-order/import-orders',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns Wealthlane_AwardSettlementService_Dtos_Common_GenericTaskResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardSettlementApiAppTradeOrderBackgroundImportOrders(
formData?: {
File?: Blob;
},
): CancelablePromise<Wealthlane_AwardSettlementService_Dtos_Common_GenericTaskResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award-settlement/api/app/trade-order/background-import-orders',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param isimport 
     * @param requestBody 
     * @returns Wealthlane_AwardSettlementService_Dtos_Common_GenericBackgroundValidationResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardSettlementApiAppTradeOrderValidateOrderImportExcelData(
isimport?: boolean,
requestBody?: Array<Wealthlane_AwardSettlementService_Dtos_TradeOrder_TradeOrderExportDto>,
): CancelablePromise<Wealthlane_AwardSettlementService_Dtos_Common_GenericBackgroundValidationResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award-settlement/api/app/trade-order/validate-order-import-excel-data',
            query: {
                'isimport': isimport,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAwardSettlementApiAppTradeOrderCancelExpiredOptionExercise(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award-settlement/api/app/trade-order/cancel-expired-option-exercise',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
